const WindowTypes = {
  EXPLORER: 0,
  MEDIA: 1,
  FILE: 2,
  RAW: 3,
  APP: 4,
};

class WindowManager {
  constructor(windows, saveCallBack) {
    this.explorers = [];
    this.media = [];
    this.files = [];
    this.raw = [];
    this.apps = [];
    this.saveCallBack = saveCallBack;
    this.processWindows(windows);
  }

  processWindows(windows) {
    for (let window of windows) {
      switch (window.type) {
        case WindowTypes.EXPLORER:
          this.explorers.push(window.meta);
          break;
        case WindowTypes.MEDIA:
          this.media.push(window.meta);
          break;
        case WindowTypes.FILE:
          this.files.push(window.meta);
          break;
        case WindowTypes.RAW:
          this.files.push(window.meta);
          break;
        case WindowTypes.APP:
          this.files.push(window.meta);
          break;
        default:
          break;
      }
    }
  }

  encodeWindows() {
    const windows = [];
    for (let explorer in this.explorers) {
      windows.push({ type: WindowTypes.EXPLORER, meta: explorer });
    }
    for (let media in this.media) {
      windows.push({ type: WindowTypes.MEDIA, meta: media });
    }
    for (let file in this.files) {
      windows.push({ type: WindowTypes.FILE, meta: file });
    }
    for (let raw in this.raw) {
      windows.push({ type: WindowTypes.RAW, meta: raw });
    }
    for (let app in this.apps) {
      windows.push({ type: WindowTypes.APP, meta: app });
    }
    return windows;
  }

  getWindow(index, type) {
    switch (type) {
      case WindowTypes.EXPLORER:
        return this.explorers[index];
      case WindowTypes.MEDIA:
        return this.media[index];
      case WindowTypes.FILE:
        return this.files[index];
      case WindowTypes.RAW:
        return this.raw[index];
      case WindowTypes.APP:
        return this.apps[index];
      default:
        return null;
    }
  }

  addWindow(meta, type) {
    switch (type) {
      case WindowTypes.EXPLORER:
        this.explorers.push(meta);
        break;
      case WindowTypes.MEDIA:
        this.media.push(meta);
        break;
      case WindowTypes.FILE:
        this.files.push(meta);
        break;
      case WindowTypes.RAW:
        this.files.push(meta);
        break;
      case WindowTypes.APP:
        this.files.push(meta);
        break;
      default:
        break;
    }
    this.saveCallBack();
  }

  deleteWindow(index, type) {
    switch (type) {
      case WindowTypes.EXPLORER:
        this.explorers.splice(index, 1);
        break;
      case WindowTypes.MEDIA:
        this.media.splice(index, 1);
        break;
      case WindowTypes.FILE:
        this.files.splice(index, 1);
        break;
      case WindowTypes.RAW:
        this.files.splice(index, 1);
        break;
      case WindowTypes.APP:
        this.files.splice(index, 1);
        break;
      default:
        break;
    }
    this.saveCallBack();
  }

  popWindow(index, type) {
    const meta = this.getWindow(index, type);
    if (meta === null) {
      return false;
    }
    this.deleteWindow(index, type);
    this.addWindow(meta, type);
    this.saveCallBack();
  }
}

export default WindowManager;
